var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutside,
      expression: "clickOutside"
    }],
    attrs: {
      "value": _vm.value,
      "content-class": _vm.contentClass,
      "max-width": _vm.maxWidth,
      "retain-focus": _vm.retainFocus,
      "fullscreen": _vm.fullscreen
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_vm.icon ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": _vm.iconColor
    }
  }, [_vm._v(_vm._s(_vm.icon))])], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": _vm.icon ? 10 : 12
    }
  }, [_vm._t("default")], 2)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": _vm.cancelColor,
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelText) + " ")]), _c('v-btn', {
    attrs: {
      "color": _vm.confirmColor,
      "text": "",
      "disabled": _vm.confirmDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('confirm');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmText) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }